// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3200) return "static/chunks/3200-38660e8890211bdc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "2de5cb12d3bbf449" + ".js";
};